
import { defineComponent, reactive, toRefs } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import * as Types from "@/store/action-types";
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const state = reactive({
      userName: "",
      passWord: "",
      clickModalClose: false,
    });
    function handleClose() {
      state.userName = "";
      state.passWord = "";
      context.emit("close-modal");
    }
    async function login() {
      if (state.userName.length === 0) {
        ElMessage({ message: "请输入账号", type: "error" });
        return false;
      }

      if (state.passWord.length === 0) {
        ElMessage({ message: "请输入密码", type: "error" });
        return false;
      }
      store
        .dispatch(`user/${Types.SET_USER_LOGIN}`, {
          mobile: state.userName,
          password: state.passWord,
        })
        .then((res) => {
          if (res.code === 1) {
            handleClose();
            location.href = "/";
          }
        })
        .catch((res) => {
          if (res.msg != undefined) {
            ElMessage({ message: res.msg, type: "error" });
          } else {
            ElMessage({ message: res, type: "error" });
          }
        });
    }
    return {
      ...toRefs(state),
      login,
      handleClose,
    };
  },
});
